/* Portal configurations - global scope */

const helper = {};

// base config
helper.portal_name = 'SoundeesMusic';
helper.portal_url = "soundees-music.com";
helper.type='music';

// api methods
helper.api_url = 'https://api.hubdelivery.io';
helper.api_methods = {
    'music': {
        'categories' : '/content/music/categories',
        'channels_by_category' : '/content/music/channels_by_category',
        'channels_by_list' : '/content/music/channels_by_list',
        'channel' : '/content/music/channel',
        'playlist' : '/content/music/playlist',
        'track' : '/content/music/track'
    },
    'legals': {
        'contact' : '/content/legals/contact',
        'faq' : '/content/legals/faq',
        'terms' : '/content/legals/terms',
        'customer_service_policy': '/content/legals/customer_service_policy',
        'privacy' : '/content/legals/privacy',
        'cookies_policy' : '/content/legals/cookies_policy',
        'unsubscribe_text' : '/content/legals/unsubscribe',
        'unsubscribe_phone' : '/store/UnsubscribePhoneNumber'
    },
    'general': {
        'login' : '/store/checkAccessCode',
        'login_phone': '/store/loginWithPhone',
        'check_phone_login': '/store/checkPhoneLoginAllowed'
    }
};

helper.country_phone_format = {
    'UK': '44xxxxxxxxx',
    'LT': '6xxxxxxx',
    'DE': '42xxxxxxxxx',
    'BG': '08xxxxxxxx',
    'SK': '09xxxxxxxx',
    'PL': 'xxxxxxxxx',
    'RS': '06xxxxxxxx',
    'SG': '44xxxxxxxxx',
    'CH': '07xxxxxxxx',
    'DK': 'xxxxxxxx',
    'LV': '2xxxxxxx',
    'CZ': '7xxxxxxxx',
    'TR': '05xxxxxxxxx',
    'SI': '0xxxxxxxx',
    'RO': '07xxxxxxxx',
    'TH': '0xxxxxxxxx'
};

helper.country_default_language = {
    'UK': 'EN',
    'IE': 'EN',
    'LU': 'EN',
    'CH': 'CH',
    'SG': 'EN',
    'DK': 'DK',
    'LV': 'LV',
    'CZ': 'CZ',
    'TR': 'TR'
};

helper.country_register_landing = {
    'UK': 'https://uk.soundees-music.com/register',
    'BG': 'https://premium.soundees-music.com/bgSm01/',
    'DE': 'https://premium.soundees-music.com/deSm01/clk/',
    'RS': 'https://premium.soundees-music.com/rSSm01/',
    'LT': 'https://premium.soundees-music.com/ltSm01/',
    'SG': 'https://uk.soundees-music.com/register',
    'SI': 'https://premium.soundees-music.com/sISm00/',
    'CZ': 'https://premium.soundees-music.com/cZSM04/',
    'LV': 'https://premium.soundees-music.com/lVSM03/mo/',
    'RO': 'https://premium.soundees-music.com/rOSm01/',
    'CH': 'https://premium.soundees-music.com/cHSm01/',
    'TH': 'https://premium.soundees-music.com/tHSm01/'
};


export const helpers = helper;
